<div class="d-flex justify-content-center">
	<div style="width: 400px">
		<div class="card card-border-color card-border-color-primary p-shadow-8" *ngIf="eGiftVenue">
			<div class="card-header text-center flex-column">
				<img
					*ngIf="eGiftVenue.logoS3Key"
					class="w-100"
					[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + eGiftVenue.venueKey + '/' + eGiftVenue.logoS3Key"
				/>
				<img
					*ngIf="!eGiftVenue.logoS3Key"
					class="w-100"
					[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueKey + '/logo.png'"
				/>
				<div
					class="disclaimer"
					*ngIf="eGiftVenue && eGiftVenue.headerMessage"
					[style.background-color]="eGiftVenue.Venue.ooVenue.styles?.headerBgColor"
					[style.color]="eGiftVenue.Venue.ooVenue.styles?.headerTextColor"
				>
					<div style="max-width: 1200px" class="d-flex h-100 align-items-center mx-auto">
						{{ eGiftVenue.headerMessage }}
					</div>
				</div>
				<div *ngIf="!eGiftVenue.headerMessage">
					<h4>Gift Cards from {{ eGiftVenue.Venue.ooVenue.name }}</h4>
				</div>
			</div>
			<div *ngIf="!eGiftVenue.enabled">
				<div class="h4">Sorry, we're not offering gift cards at this time.</div>
			</div>
			<div *ngIf="eGiftVenue.enabled">
				<div *ngIf="prepurchase && !transactionComplete">
					<app-e-gift-value-select
						[eGiftVenue]="eGiftVenue"
						(selectedAmountOutput)="value = $event.value; transactionAmount = $event.amount"
						(selectedPromoCode)="promoCode = $event"
					></app-e-gift-value-select>
					<app-e-gift-detail [eGiftVenue]="eGiftVenue" (transactionDetail)="transaction = $event; checkout()"> </app-e-gift-detail>
				</div>
				<div *ngIf="!prepurchase && !transactionComplete">
					<app-e-gift-checkout
						[eGiftVenue]="eGiftVenue"
						[ooVenue]="orderService.venueService.ooVenue"
						[transaction]="transaction"
						(transactionComplete)="completePurchase($event)"
					></app-e-gift-checkout>
				</div>
				<div *ngIf="transactionComplete" class="flex flex-column" style="text-align: center">
					<div class="m-2">
						<h4>Thank you for your purchase!</h4>
					</div>
					<div class="m-2">Gift Card Value: {{ transaction.value | currency }}</div>
					<div class="m-2">Trxn: {{ transaction.key }}</div>
					<div class="m-2" *ngIf="transaction.delaySend">
						The gift card will be emailed to {{ transaction.recipientEmail }} on {{ moment(transaction.sendDateTime).format("l") }} at
						{{ moment(transaction.sendDateTime).format("LT") }}
					</div>
					<div class="m-2" *ngIf="!transaction.delaySend">The gift card will be emailed to {{ transaction.recipientEmail }} ASAP</div>
					<div class="mt-4">
						<p-button pRipple styleClass="p-button-raised w-100" (click)="reset()" label="Purchase another card"></p-button>
					</div>
				</div>
			</div>

			<app-venue-info-footer
				*ngIf="orderService.venueService.ooVenue"
				[ooVenue]="orderService.venueService.ooVenue"
				[footerMessage]="eGiftVenue.footerMessage"
			></app-venue-info-footer>

			<div class="d-flex justify-content-center">
				<app-terms-of-service-footer></app-terms-of-service-footer>
			</div>
		</div>
	</div>
</div>
